import { render, staticRenderFns } from "./ProfileCertification.vue?vue&type=template&id=8aefa17e"
import script from "./ProfileCertification.vue?vue&type=script&lang=ts"
export * from "./ProfileCertification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aefa17e')) {
      api.createRecord('8aefa17e', component.options)
    } else {
      api.reload('8aefa17e', component.options)
    }
    module.hot.accept("./ProfileCertification.vue?vue&type=template&id=8aefa17e", function () {
      api.rerender('8aefa17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/certifications/ProfileCertification.vue"
export default component.exports